import React, { useEffect, useState } from 'react';
// Componentes
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
// Mui
import { TextField } from '@material-ui/core';
import { Search, Visibility } from '@material-ui/icons';
// Services
import { wsFindBy, wsGetAll } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Promoción', accessor: 'promotion_description', minWidth: 350 },
  { Header: 'Cod Producto', accessor: 'ItemCode', width: 125 },
  { Header: 'Producto', accessor: 'ItemName', width: 200 },
  { Header: 'Zona', accessor: 'zone', width: 100 },
  { Header: 'Almacén', accessor: 'warehouse', width: 100 },
  { Header: 'Stock', accessor: 'Stock', width: 100 },
  { Header: 'Cosumido x Dia', accessor: 'quantity_per_day', width: 150 },
  { Header: 'Dias restantes', accessor: 'dias_faltantes', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PromotionsWithLowStock() {
  const [ItemCode, setItemCode] = useState('');
  const [ItemName, setItemName] = useState('');
  const [days, setDays] = useState('5');
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();
  const [zones, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function listZones() {
    setDataLoading(true);
    let res = await wsGetAll('base/zone');
    setDataLoading(false);
    if (res.success) {
      setZones(res.data);
    }
  }

  async function listProviders() {
    setDataLoading(true);
    let res = await wsFindBy('base/business-partner', {
      CardType: 'S',
      QryGroup1: 'Y',
    });
    setDataLoading(false);

    if (res.success) {
      setProviders(res.data);
    }
  }

  async function listPromotions() {
    setDataLoading(true);
    let data = {};
    if (ItemCode.length > 0) {
      data.ItemCode = ItemCode;
    }
    if (ItemName.length > 0) {
      data.ItemName = ItemName;
    }
    if (selectedZones.length > 0) {
      data.zones = selectedZones.map((zone) => zone.id);
    }
    if (selectedProvider !== undefined) {
      data.base_business_partner_id = selectedProvider.id;
    }
    if (days.length > 0) {
      data.days = days;
    }
    setLoading(true);
    let res = await wsFindBy('prom/promotion/with-low-stock', data);
    setDataLoading(false);
    setLoading(false);
    if (res.success) {
      setPromotions(res.data);
    }
  }

  useEffect(() => {
    listZones();
    listProviders();
  }, []);

  return (
    <CardContainer /*title="Promociones con bajo stock"*/ title={(<>Promociones con bajo stock {dataLoading && <LoadingSpinner />}</>)}>
      {/* Filtros */}
      <GridContainer>
        {/* Proveedor */}
        <GridItem xs={12} sm={6} md={4} lg={3}>
          <SelectAutoComplete
            label="Proveedor"
            textField="CardName"
            options={providers}
            selectedOption={selectedProvider}
            setSelectedOption={setSelectedProvider}
          />
        </GridItem>
        {/* Zona */}
        <GridItem xs={12} sm={6} md={4} lg={3}>
          <MultiComplete
            label="Zona"
            textField="description"
            options={zones}
            disabled={loading}
            selected={selectedZones}
            setSelected={setSelectedZones}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Cod Producto"
            margin="normal"
            value={ItemCode}
            onChange={(e) => setItemCode(e.target.value)}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Producto"
            margin="normal"
            value={ItemName}
            onChange={(e) => setItemName(e.target.value)}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            label="Dias"
            margin="normal"
            type="number"
            value={days}
            onChange={(e) => setDays(e.target.value)}
            inputProps={{ min: 1, max: 30 }}
          />
        </GridItem>
        <RegularButton justIcon color="success" round onClick={listPromotions}>
          <Search />
        </RegularButton>
      </GridContainer>

      {/* Tabla */}
      <GridContainer>
        <GridItem xs={12}>
          <ReactTable
            columns={columns}
            formatDate="DD-MM-YYYY HH:mm"
            data={promotions.map((prom, index) => {
              return {
                num: (
                  <>
                    {index + 1}
                    <RegularButton
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => {
                        window.open(
                          `/admin/articulos/operaciones/promociones/${prom.prom_promotion_id}`,
                          '_blank',
                        );
                      }}
                    >
                      <Visibility />
                    </RegularButton>
                  </>
                ),
                promotion_description: `(${prom.prom_promotion_id}) ${prom.promotion_description}`,
                ItemCode: prom.ItemCode,
                ItemName: prom.ItemName,
                zone: prom.zone_description,
                warehouse: prom.WhsName,
                Stock: parseFloat(prom.Stock),
                quantity_per_day: parseFloat(prom.quantity_per_day),
                dias_faltantes: parseFloat(prom.dias_faltantes),
              };
            })}
          />
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default PromotionsWithLowStock;
